const csvCell = (value) => {
    const text = value == null ? "" : String(value);
    return /[",\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
};

const downloadCsv = ({ columns, rows, filename }) => {
    const header = columns.map((column) => csvCell(column.label)).join(",");
    const body = rows.map((row) =>
        columns.map((column) => csvCell(column.value(row) ?? "")).join(","),
    );
    const blob = new Blob([[header, ...body].join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};

export { downloadCsv };
